<template>
  <div class="flex-auto ce-search">
    <div class="ce-container flex pt4">
      <filter-bar group-filters>
        <slot />

        <div
          class="ce-searchFilterBar-section createCatalogCta"
          v-if="activeUser && links.digitalCatalogsPage">
          <div>
            <label>{{ $t('digitalCatalog.promotion.headline') }}</label>
            <div class="ms-2 mb2">
              {{ $t('digitalCatalog.promotion.description') }}
            </div>
            <div>
              <a
                class="ce-btn ce-btn-light ce-btn--small ce-btn--fullWidth center"
                :href="`${links.digitalCatalogsPage}workbench`">
                <fa-icon
                  class="mr1"
                  :icon="['fas', 'book']" />
                {{ $t('digitalCatalog.promotion.cta') }}
              </a>
            </div>
          </div>
        </div>
      </filter-bar>
      <main>
        <FormulationResultsHint />

        <div class="flex">
          <div class="ce-mobileFilterBarToggle mr2">
            <button
              class="ce-btn ce-btn-grey"
              @click.prevent="$store.dispatch('toggleMobileFilterBar')">
              <fa-icon icon="filter" />
            </button>
          </div>

          <search-field
            on-search-page
            class="flex-auto"
            :value="searchTerm"
            :active-industry="activeIndustries && activeIndustries.length === 1 ? activeIndustries[0] : null"
            :active-filters="urlFilters"
            @search="$store.dispatch('setSearchTerm', $event)" />
        </div>

        <pigment-results />
      </main>
    </div>

    <basket-industry-modal
      v-if="addToBasketTemp" />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import SearchField from 'components/product-search/SearchField.vue';
import FilterBar from 'components/product-search/FilterBar.vue';
import PigmentResults from 'components/product-search/PigmentResults.vue';
import BasketIndustryModal from 'components/product-comparison/BasketIndustryModal.vue';
import FormulationResultsHint from 'components/product-search/FormulationResultsHint.vue';

export default {
  mounted() {
    this.search();
  },
  watch: {
    urlFilters() {
      this.triggerSearch();
    }
  },
  components: {
    SearchField, FilterBar, PigmentResults, BasketIndustryModal, FormulationResultsHint,
  },
  computed: {
    ...mapState('user', ['activeUser']),
    ...mapState('generic', ['links']),
    ...mapGetters(['urlFilters', 'searchTerm', 'activeIndustries']),
    ...mapState('productComparison', ['addToBasketTemp'])
  },
  methods: {
    ...mapActions(['search']),
    triggerSearch() {
      this.$store.dispatch('search');
    },
  }
};
</script>

<style lang="less">
  @import (reference) '~styles/includes/base';

  .ce-search {
    .ce-searchFilterBar {
      .ce-contentPromotionSnippet {
        display: block;

        img {
          max-width: 100%;
          height: auto;
        }

        .ce-contentPromotionSnippet-imageContainer {
          margin-bottom: 0;
        }

        p {
          display: none;
        }

        @media screen and (min-width: @breakpoint-md) {
          margin-top: -125px;
        }

        + .createCatalogCta {
          border-top: 1px solid @color-mono-90;
          padding-top: @space-4;
          margin-top: 0;
        }
      }

      .createCatalogCta {
        margin-bottom: @space-4;
        padding-bottom: @space-4;
        border-bottom: 1px solid @color-mono-90;
        margin-top: -100px;
      }
    }

    main {
      .flex-auto;
      padding: @space-3;
      background: @color-mono-100;

      @media screen and (min-width: @breakpoint-md) {
        .ce-mobileFilterBarToggle {
          display: none;
        }
      }
    }
  }
</style>
